import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useFont } from "../../contexts/FontContext/FontContext";
import { Link } from "react-router-dom";
import styles from "./Header.module.css";
import Logo from "../Logo/Logo";

const Header = () => {
    const [scrollPosition, setScrollPosition] = useState(0);
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const fontSchemes = useFont();    
    const fontFamilyOne = fontSchemes.scheme_one; 

    const handleScroll = () => {
        const position = window.pageYOffset; // Get the vertical scroll position
        setScrollPosition(position); // Update scroll position state
    };

    // Hide the dropdown when width is expanded
    const handleResize = () => {
        const screenWidth = window.innerWidth;
        setScreenWidth(screenWidth);
        if (screenWidth > 1000) { setDropdownVisible(false); }
    };

    const scrollToTop = () => {
        window.scrollTo({top: 0, behavior: "smooth"});
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll, { passive: true }); //passive to improve performance
        window.addEventListener("resize", handleResize);
        handleScroll(); // Call handleScroll initially to set the scroll position
        // Cleanup event listeners on component unmount
        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const toggleDropdown = () => { setDropdownVisible(prevState => !prevState); }; // Toggle dropdown visibility
    const navigate = useNavigate();

    return (
        <header className={`${styles.header} ${scrollPosition > 1 ? styles.scrolled : ''}`}> 
            <Logo style={{ top: "5px", left: screenWidth < 481 ? "40px" : screenWidth < 1000 ? "80px" : "150px" }} />
            <div className={`${styles.header_left_buttons} ${fontFamilyOne}`}>
                <div className={styles.about_button}>About</div>
                <div className={styles.integrations_button}>Integrations</div>
                <div className={styles.pricing_button}>Pricing</div>
            </div>
            <div className={styles.login_signup_buttons}>
                <Link to="/login" className={`${styles.header_right_buttons} ${styles.login_button} ${fontFamilyOne} ${scrollPosition > 1 ? styles.scrolled : ""}`}>Log in</Link>
                <Link to="/signup" className={`${styles.header_right_buttons} ${styles.signup_button} ${fontFamilyOne}`}>Create an Account</Link>
                <div className={styles.header_left_buttons_toggle_wrapper} onClick={toggleDropdown}>
                    <div className="header_buttons_toggle_lines"></div>
                    <div className="header_buttons_toggle_lines"></div>
                    <div className="header_buttons_toggle_lines"></div>
                </div>
            </div>
            <div className={`${styles.header_left_buttons_dropdown} ${fontFamilyOne}`} style={{ display: dropdownVisible ? "flex" : "none" }}>
                <div className={styles.header_left_dropdown_buttons}>About</div>
                <div className={styles.header_left_dropdown_buttons}>Integrations</div>
                <div className={styles.header_left_dropdown_buttons}>Pricing</div>
                <div className={styles.header_left_dropdown_buttons} onClick={() => navigate("/login")}>Log in</div>
          </div>
        </header>
      );
    };

export default Header;